<template>
	<div>
		<b-card class="p-1 mr-1" no-body>
			<b-row class="mb-1">
				<b-col class="d-flex justify-content-end">
					<b-button class="d-inline text-nowrap" variant="outline-primary" @click="openUpsertModal()">
						<FeatherIcon icon="PlusIcon" size="20" />
					</b-button>
				</b-col>
			</b-row>
			<b-row class="mb-1">
				<b-col class="d-flex align-items-center">
					<small class="text-secondary">
						Mostrando {{ pagination.from }} a {{ pagination.to }} de {{ pagination.total }} beneficiarios
					</small>
				</b-col>
				<b-col class="d-flex align-items-center justify-content-end flex-wrap gap-x-4 gap-y-1">
					<b-pagination
						v-model="pagination.curPage"
						:total-rows="pagination.total"
						:per-page="pagination.perPage"
						first-number
						last-number
						class="mb-0 mt-1 mt-sm-0"
						prev-class="prev-item"
						next-class="next-item"
					>
						<template #prev-text>
							<feather-icon icon="ChevronLeftIcon" size="18" />
						</template>
						<template #next-text>
							<feather-icon icon="ChevronRightIcon" size="18" />
						</template>
					</b-pagination>
				</b-col>
			</b-row>
			<b-row class="mb-1">
				<b-col cols="12" xl="7" class="d-flex align-items-center justify-content-start mt-1 mb-md-0">
					<label>Mostrar</label>
					<v-select
						v-model="pagination.perPage"
						:options="perPageOptions"
						:clearable="false"
						class="per-page-selector d-inline-block mx-50"
						style="width: 90px"
					/>
					<label class="mr-2">registros</label>
					<feather-icon class="cursor-pointer" icon="RefreshCcwIcon" size="20" @click="refresh" />
				</b-col>
			</b-row>
			<b-table-simple sticky-header="60vh">
				<b-thead class="text-center">
					<b-tr>
						<b-th>Nombre</b-th>
						<b-th>Banco</b-th>
						<b-th>Nro Cuenta</b-th>
						<b-th>CCI</b-th>
						<b-th>Activa</b-th>
						<b-th>Fecha de Creación</b-th>
						<b-th>Torneos</b-th>
						<b-th>Acciones</b-th>
					</b-tr>
				</b-thead>
				<b-tbody class="text-center">
					<b-tr v-for="row in rows" :key="row.id">
						<b-td>{{ row.name }}</b-td>
						<b-td>{{ row.bank }}</b-td>
						<b-td>{{ row.account_number }}</b-td>
						<b-td>{{ row.cci }}</b-td>
						<b-td>
							<b-badge pill :variant="'light-' + (row.is_active ? 'success' : 'danger')">
								{{ row.is_active ? "SÍ" : "NO" }}
							</b-badge>
							<b-form-checkbox
								v-model="row.is_active"
								:true-value="1"
								:false-value="0"
								name="check-button"
								switch
								:disabled="row.status == 'OCUPADO'"
								class="mt-1 text-center"
								@change="toggleStatus(row)"
								style="margin-left: 0.5rem"
							/>
						</b-td>
						<b-td>
							<div>{{ row.created_by_name }}</div>
							<div>
								{{ row.created_at | myGlobalDayWithHour }}
							</div>
						</b-td>
						<b-td>
							<div v-for="(tournament, index) in row.tournaments" :key="`tournament-${index}`">
								{{ tournament.name || "-" }}
							</div>
						</b-td>
						<b-td>
							<div class="d-flex justify-content-center" style="gap: 1rem">
								<feather-icon
									size="20"
									icon="EditIcon"
									class="text-warning cursor-pointer"
									@click="openUpsertModal(row)"
								/>
								<feather-icon
									size="20"
									icon="TrashIcon"
									class="text-danger cursor-pointer"
									@click="destroy(row)"
								/>
								<feather-icon
									size="20"
									icon="PlusIcon"
									v-b-tooltip.hover="'Asignar torneo'"
									class="text-warning cursor-pointer"
									@click="openSelectTournamentModal(row)"
								/>
								<feather-icon
									size="20"
									icon="ListIcon"
									v-b-tooltip.hover="'Historial de torneos'"
									class="text-warning cursor-pointer"
									@click="openTournamentTrackingModal(row)"
								/>
							</div>
						</b-td>
					</b-tr>
					<b-tr v-if="rows.length == 0">
						<b-td colspan="4">
							<p class="mb-0">No hay registros por mostrar</p>
						</b-td>
					</b-tr>
				</b-tbody>
			</b-table-simple>
		</b-card>
		<UpsertTournamentBeneficiaryModal
			v-if="showUpsertModal"
			:beneficiary="selectedBeneficiary"
			@refresh="getBeneficiaries"
			@close="showUpsertModal = false"
		/>
		<SelectTournamentModal
			v-if="showSelectTournamentModal"
			@close="showSelectTournamentModal = false"
			@refresh="getBeneficiaries"
			:beneficiary="selectedBeneficiary"
			:tournaments="tournaments"
		/>
		<TournamentTrackingModal
			v-if="showTournamentTrackingModal"
			:beneficiary="selectedBeneficiary"
			@close="showTournamentTrackingModal = false"
		/>
	</div>
</template>

<script>
import TournamentBeneficiariesService from "@/views/brain/tournament/views/beneficiaries/beneficiaries.service.js"
import UpsertTournamentBeneficiaryModal from "@/views/brain/tournament/views/beneficiaries/components/UpsertTournamentBeneficiaryModal.vue"
import tournamentSeasonService from "@/services/tournament/season.service"
import tournamentService from "@/services/tournament/default.service"
import SelectTournamentModal from "@/views/brain/tournament/views/beneficiaries/components/SelectTournamentModal.vue"
import TournamentTrackingModal from "@/views/brain/tournament/views/beneficiaries/components/TournamentTrackingModal.vue"
export default {
	data: () => ({
		showSelectTournamentModal: false,
		isLoading: false,
		rows: [],
		perPageOptions: [10, 25, 50],
		pagination: {
			total: 0,
			curPage: 1,
			perPage: 25,
			from: 0,
			to: 0,
		},
		showUpsertModal: false,
		currentSeason: null,
		tournaments: [],
		selectedBeneficiary: null,
		showTournamentTrackingModal: false,
	}),
	components: {
		UpsertTournamentBeneficiaryModal,
		SelectTournamentModal,
		TournamentTrackingModal,
	},
	computed: {},
	methods: {
		openTournamentTrackingModal(beneficiary) {
			this.selectedBeneficiary = beneficiary
			this.showTournamentTrackingModal = true
		},
		openSelectTournamentModal(beneficiary) {
			this.selectedBeneficiary = beneficiary
			this.showSelectTournamentModal = true
		},
		async getSeasons() {
			const { data } = await tournamentSeasonService.getSeasons()
			const seasons = data
			this.currentSeason = seasons.find((it) => it.active_season == 1)
			this.getTournaments()
		},
		async getTournaments() {
			const { data } = await tournamentService.getTournaments({
				start_date: this.currentSeason.start,
				end_date: this.currentSeason.end,
			})
			this.tournaments = data.data
		},
		refresh() {
			this.getBeneficiaries()
		},
		openUpsertModal(beneficiary = null) {
			this.selectedBeneficiary = beneficiary
			this.showUpsertModal = true
		},
		async destroy(row) {
			const { isConfirmed } = await this.showConfirmSwal({
				title: `¿Estás seguro de que quieres eliminar a ${row.name}?`,
				text: "",
			})
			if (!isConfirmed) return
			try {
				this.isPreloading(true)
				await TournamentBeneficiariesService.destroy(row.id)
				this.getBeneficiaries()
				this.showSuccessToast("Beneficiario eliminado correctamente")
			} catch (error) {
				console.log(error)
			} finally {
				this.isPreloading(false)
			}
		},
		async toggleStatus(row) {
			const { isConfirmed } = await this.showConfirmSwal({
				title: `¿Estás seguro de que quieres ${row.is_active ? "activar" : "desactivar"} a ${row.name}?`,
				text: "",
			})
			if (!isConfirmed) {
				row.is_active = !row.is_active
				return
			}
			try {
				this.isPreloading(true)
				await TournamentBeneficiariesService.toggleStatus(row.id)
				this.showSuccessToast("Estado actualizado correctamente")
			} catch (error) {
				console.log(error)
			} finally {
				this.isPreloading(false)
			}
		},
		async getBeneficiaries(page = 1) {
			this.isPreloading(true)
			try {
				const { data } = await TournamentBeneficiariesService.getBeneficiaries({
					per_page: this.pagination.perPage,
					page: page,
				})
				this.pagination.curPage = data.current_page
				this.pagination.total = data.total
				this.pagination.from = data.from
				this.pagination.to = data.to
				this.rows = data.data.map((reason) => ({
					...reason,
					is_active: reason.is_active === 1 ? true : false,
				}))
			} catch (error) {
				console.log(error)
			} finally {
				this.isPreloading(false)
			}
		},
	},
	watch: {
		tabIndex() {
			this.getBeneficiaries()
		},
		"pagination.curPage": async function () {
			await this.getBeneficiaries(this.pagination.curPage)
		},
		"pagination.perPage": async function () {
			await this.getBeneficiaries()
		},
	},
	mounted() {
		this.getSeasons()
		this.getBeneficiaries()
	},
}
</script>
<style lang="scss" scoped></style>
